/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Kpi_No_UsersInputs */



/**
* | output |
* | --- |
* | "No users yet" |
*
* @param {Partner_Admin_Kpi_No_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_kpi_no_users = /** @type {((inputs?: Partner_Admin_Kpi_No_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Kpi_No_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Nutzer")
	return /** @type {LocalizedString} */ ("No users yet")
});